import URI from 'urijs'
import { config } from '@/plugins/env.config'
import axios from 'axios';

async function getSponsorForm (sponsorSlug, attemptNumber = 1){
    const getSponsorFormUri = new URI(config.apiBaseUrl)
    getSponsorFormUri.segment('beneficiary-lookup')
    getSponsorFormUri.segment('v1')
    getSponsorFormUri.segment('sponsors')
    getSponsorFormUri.segment(sponsorSlug)
    getSponsorFormUri.segment('forms')

    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('clientToken')}`
    }

    try {
        return await axios.get(getSponsorFormUri.toString(), {
            headers: getTokenHeaders
        })
    } catch (error) {
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response
        const status = response.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return getSponsorForm(sponsorSlug, attemptNumber + 1)
        }

        throw error
    }
}

async function getBeneficiaries (payload, attemptNumber = 1){
    const getBeneficiariesUri = new URI(config.apiBaseUrl)
    getBeneficiariesUri.segment('beneficiary-lookup')
    getBeneficiariesUri.segment('v1')
    getBeneficiariesUri.segment('sponsors')
    getBeneficiariesUri.segment(payload.sponsorSlug)
    getBeneficiariesUri.segment('search')

    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('clientToken')}`
    }
    
    try {

        let response = await axios.post(getBeneficiariesUri.toString(), payload.request, {
            headers: getTokenHeaders
        });

        if(!response){
            throw 'Search response was not found for sponsorSlug: ' 
                    + payload.sponsorSlug 
                    + ' ,formSlug: ' + payload.request.formSlug
                    + ' ,providerSlug: ' + payload.request.providerSlug
        }
        else{
            return response
        }

    } catch (error) {
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response
        const status = response.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return getBeneficiaries(payload, attemptNumber + 1)
        }

        throw error
    }
}

async function getBeneficiaryMonitor(payload, attemptNumber = 1) {
    const monitorId = new URI(payload)

    const getTokenHeaders = {
        Authorization: `Bearer ${localStorage.getItem('clientToken')}`
    }

    try{

        let response = await axios.get(monitorId, {
            headers: getTokenHeaders
        });     
        
        if(response.data.status === 'IN_PROGRESS'){
            const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 2000))
            return getBeneficiaryMonitor(payload)
        }
        return response

    }catch(error){
        const maxAttempts = config.getTokenMaxAttempts
        const attemptDelayInSeconds = config.getTokenAttemptDelayInSeconds

        const response = error.response
        const status = response.status

        if (status === 500 && attemptNumber < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, attemptDelayInSeconds * 1000))
            return getBeneficiaryMonitor(payload, attemptNumber + 1)
        }

        throw error
    }
}

export default { 
    getSponsorForm,
    getBeneficiaries,
    getBeneficiaryMonitor
}